import React, {useState} from 'react';
import styled from "styled-components";
import internetTariffIcon from '../../ui/icons/activate.svg';
import internetTariffReconnectIcon from '../../ui/icons/extra_mb.svg';
import changeTariffIcon from '../../ui/icons/sim_change.svg';
import extraMenuIcon from '../../ui/icons/extra.svg';
import extraMbIcon from '../../ui/icons/extra_menu_mb.svg';
import extraBalanceIcon from '../../ui/icons/extra_menu_balance.svg';
import arrowNextIcon from '../../ui/icons/arrow_next.svg';
import arrowBackIcon from '../../ui/icons/arrowBack-blue.svg';
import {theme} from "../../styles/theme";
import {Title} from "../../styles/text";
import {Message} from "../../locale/Message";


const ServiceButton = styled.button`
		padding: 24px 24px;
		width: 100%;
		display: flex;
		justify-content: ${props => props.endIcon ? 'space-between' : 'flex-start'};
		align-items: center;
		font-weight: 500;
		font-size: 16px;
		line-height: 150%;
		color: ${theme.colors.black};
		img {
				margin-right: 20px;
		}
		border-radius: 6px;
		border: none;
		background-color: ${theme.colors.black_4};
		cursor: pointer;
		margin-bottom: 8px;
    @media screen and (max-width: 640px) {
        font-size: 14px;
    }
`

const BackButton = styled.button`
		border: none;
		background-color: inherit;
		display: flex;
		align-items: center;
		justify-content: flex-start;
    cursor: pointer;
		font-weight: 500;
    font-size: 16px;
    line-height: 150%;
		color: #1d8de1;
		padding: 0;
		margin-bottom: 40px;
		img {
				margin-right: 10px;
		}
`

const FlexRoot = styled.div`
		display: flex;
		justify-content: center;
		align-items: center;
`

const DefFlow = ({ setStatus, lang, type }) => {
	return (
		<>
			<Title>
				{Message.serviceTitle[lang]}
			</Title>
			<ServiceButton
				id='zero_mainScrn_unauth_intPckg_click'
				onClick={() => {
					type === 'kcell' ?
						window.ym(100027491,'reachGoal','zero_mainScrn_unauth_intPckg_click') :
						window.ym(99833193,'reachGoal','zero_mainScrn_unauth_intPckg_click');
					window.open(type === 'kcell' ?
						`https://www.kcell.kz/${lang}/services/665` :
						`https://activ.kz/${lang}/services/538`, '_self'
					)}}>
				<img src={internetTariffIcon} alt="connect internet tariff"/>
				<span>{Message.serviceInternetPackage[lang]}</span>
			</ServiceButton>
			<ServiceButton
				id='zero_mainScrn_unauth_rcnctTrff_click'
				onClick={() => {
					type === 'kcell' ?
						window.ym(100027491,'reachGoal','zero_mainScrn_unauth_rcnctTrff_click') :
						window.ym(99833193,'reachGoal','zero_mainScrn_unauth_rcnctTrff_click');
					window.open(type === 'kcell' ?
						`https://www.kcell.kz/${lang}/home` :
						`https://activ.kz/${lang}/home`, '_self'
					)}}>
				<img src={internetTariffReconnectIcon} alt="reconnect internet tariff"/>
				<span>{Message.serviceReconnect[lang]}</span>
			</ServiceButton>
			<ServiceButton
				id='zero_mainScrn_unauth_chngTrff_click'
				onClick={() => {
					type === 'kcell' ?
						window.ym(100027491,'reachGoal','zero_mainScrn_unauth_chngTrff_click') :
						window.ym(99833193,'reachGoal','zero_mainScrn_unauth_chngTrff_click');
					window.open(type === 'kcell' ?
						`https://www.kcell.kz/${lang}/tariffs` :
						`https://activ.kz/${lang}/tariffs`, '_self'
					)}}>
				<img src={changeTariffIcon} alt="change tariff"/>
				<span>{Message.serviceChange[lang]}</span>
			</ServiceButton>
			<ServiceButton id='zero_mainScrn_unauth_extrSrvCrd_click' endIcon onClick={() => {
				type === 'kcell' ?
					window.ym(100027491,'reachGoal','zero_mainScrn_unauth_extrSrvCrd_click') :
					window.ym(99833193,'reachGoal','zero_mainScrn_unauth_extrSrvCrd_click');
				setStatus('extra')
				}}>
				<FlexRoot>
					<img src={extraMenuIcon} alt="extra menu"/>
					<span>{Message.serviceExtra[lang]}</span>
				</FlexRoot>
				<img src={arrowNextIcon} alt="arrow-next"/>
			</ServiceButton>
		</>
	)
}

const ExtraFlow = ({setStatus, lang, type}) => {
	return (
		<>
			<BackButton onClick={() => setStatus('default')}>
				<img src={arrowBackIcon} alt="back-icon"/>
				<span>{Message.serviceExtraBack[lang]}</span>
			</BackButton>
			<Title>
				{Message.serviceExtraTitle[lang]}
			</Title>
			<ServiceButton
				id='zero_mainScrn_unauth_extrMgbCrd_click'
				onClick={() => {
					type === 'kcell' ?
						window.ym(100027491,'reachGoal','zero_mainScrn_unauth_extrMgbCrd_click') :
						window.ym(99833193,'reachGoal','zero_mainScrn_unauth_extrMgbCrd_click');
					window.open(type === 'kcell' ?
						`https://www.kcell.kz/${lang}/services/645` :
						`https://activ.kz/${lang}/services/691`, '_self'
					)}}>
				<img src={extraMbIcon} alt="extra mb"/>
				<span>{Message.serviceExtraMb[lang]}</span>
			</ServiceButton>
			<ServiceButton
				id='zero_mainScrn_unauth_extrBlnCrd_click'
				onClick={() => {
					type === 'kcell' ?
						window.ym(100027491,'reachGoal','zero_mainScrn_unauth_extrBlnCrd_click') :
						window.ym(99833193,'reachGoal','zero_mainScrn_unauth_extrBlnCrd_click');
					window.open(type === 'kcell' ?
						`https://www.kcell.kz/${lang}/services/641` :
						`https://activ.kz/${lang}/services/718`, '_self'
					)}}>
				<img src={extraBalanceIcon} alt="extra balance"/>
				<span>{Message.serviceExtraBalance[lang]}</span>
			</ServiceButton>
		</>
	)
}


const ServiceSelect = ({ lang, type }) => {
	const [status, setStatus] = useState('default');

	return status === 'default' ?
		<DefFlow setStatus={setStatus} lang={lang} type={type} /> : <ExtraFlow setStatus={setStatus} lang={lang} type={type}/>
};

export default ServiceSelect;
